import React from 'react';
import PropTypes from 'prop-types';

const TrafficNumber = ({ traffic }) => {
  const number = traffic > 1000000 ? `${(traffic/1000000).toFixed()}M` : traffic.toLocaleString();
  return <span>{number}</span>;
};

TrafficNumber.propTypes = {
  traffic: PropTypes.number.isRequired,
};

export default TrafficNumber;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/TrafficNumber.jsx